import React from "react";
import "./gallery-card2.css";

const GalleryCard = ({ heading, imageSrc, link }) => {
  return (
    <div className="gallery-card-wrapper">
      <a href={link} target="_blank" rel="noopener noreferrer" className="gallery-card">
        <img src={imageSrc} alt={heading} />
      </a>
      {heading && <div className="card-heading">{heading}</div>}
    </div>
  );
};

export default GalleryCard;
